import BannerAnim from 'rc-banner-anim';
import 'rc-banner-anim/assets/index.css';
import TweenOne from 'rc-tween-one';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../components/Auth';
import { useUserContext } from '../../components/Context';
import { errorCatch, QueryOrder, READ, READWITH } from '../../components/Tool';
import "./index.less";

const { Element, Arrow, Thumb } = BannerAnim;
const BgElement = Element.BgElement;

export default function Dashboard(props) {
    const auth = useAuth();
    const user = useUserContext();
    const [services, setServices] = useState();
    const [context, setContext] = useState();
    const contentStyle = {
        height: '160px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
    };

    useEffect(() => {
        READWITH(auth, "Services",
            [
                QueryOrder("ID", "ASC")
            ],
            (res) => setServices(res.data),
            errorCatch
        );
        READ(auth, "Context",
            (res) => setContext(res.data),
            errorCatch
        );
    }, []);

    return (<>
        <div className="site-layout-background">
            {/* <BannerAnim prefixCls="banner-user">
                <Element
                    prefixCls="banner-user-elem"
                    key="0"
                >
                    <BgElement
                        key="bg"
                        className="bg"
                        style={{
                            // background: '#364D79',
                            // backgroundImage: "linear-gradient(to right top, #c8d16b, #bdd672, #b1da7a, #a5de84, #98e28f, #8ee69b, #83eaa7, #78edb4, #6ef1c4, #66f5d4, #61f8e3, #5ffbf1)",
                            backgroundImage: "linear-gradient(to right top, #a1f9a1, #9bf8af, #97f6bc, #96f4c7, #99f2d0, #a1f2ce, #a9f2cc, #b1f2cb, #c0f4c1, #d2f4b7, #e5f4af, #f9f3aa)",
                            // backgroundImage: "url(https://agro-platform.ru/assets/images/slider/01.jpg)",
                            // backgroundSize: "cover"
                        }}
                    />
                    <TweenOne className="banner-user-title" animation={{ y: 30, opacity: 0, type: 'from' }}
                        style={{ color: "black", fontWeight: "600" }}>
                        Соревнования под эгидой Федерации
                    </TweenOne>
                    <TweenOne className="banner-user-text"
                        animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                        style={{ color: "black", fontSize: "14px", fontWeight: "600" }}
                    >
                        Приглашаем к сотрудничеству школы и коллективы
                    </TweenOne>
                </Element>
                <Element
                    prefixCls="banner-user-elem"
                    key="1"
                >
                    <BgElement
                        key="bg"
                        className="bg"
                        style={{
                            // background: '#64CBCC',
                            // backgroundImage: "linear-gradient(to right top, #72cf72, #6dd384, #6ad795, #6bdaa5, #6eddb4, #78e1b3, #82e6b3, #8ceab2, #a3efa1, #bff290, #def480, #fff374)",
                            backgroundColor: "#FFDEE9",
                            backgroundImage: "linear-gradient(331deg, #FFDEE9 0%, #B5FFFC 100%)",
                            // backgroundImage: "url(https://agro-platform.ru/assets/images/slider/02.jpg)",
                            // backgroundSize: "cover"
                        }}
                    />
                    <TweenOne className="banner-user-title" animation={{ y: 30, opacity: 0, type: 'from' }}
                        style={{ color: "black", fontWeight: "600" }}>
                        Большой танцевальный пикник
                    </TweenOne>
                    <TweenOne className="banner-user-text"
                        animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
                        style={{ color: "black", fontSize: "14px", fontWeight: "600" }}
                    >
                        Главное событие 2020 года
                    </TweenOne>
                </Element>
            </BannerAnim> */}
            {/* <Carousel>
                <div className="carousel-page">
                    <div style={contentStyle}>
                    </div>
                </div>
                <div>
                    <h3 style={contentStyle}>2</h3>
                </div>
            </Carousel> */}
        </div>
    </>);
}